/* import __COLOCATED_TEMPLATE__ from './offer-row.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();